<!-- Common header-->
<app-header extraClass="text-gray nav-down" standardProduct=false displayNavigation=true></app-header>

<section class="experience-wrp search-result mt-6">
    <div class="container">

        <ng-container *ngIf="responseReceived && products.length > 0">
            <div class="heading-text-wrp text-center">
                <h5>Results for <span>"{{this.selectedKeyword}}"</span></h5>
                <div class="line"></div>
            </div>
            <div class="popular-experiences-wrp-inner uk-flex uk-flex-wrap uk-flex-between">
                <div class="popular-experiences-card mb-4 w-46 uk-flex" *ngFor="let product of products">
                    <div class="left-panel w-55 position-relative">
                        <ng-container *ngIf="product.tags">
                            <ng-container *ngFor="let tag of product.tags.split(',')">
                                <div class="trending bg-orange" *ngIf="tag == 'Hot Selling'">
                                    <img src="assets/images/icons/fire.png" alt="">
                                    <span>Hot Selling</span>
                                </div>

                                <div class="trending bg-purple" *ngIf="tag == 'Limited Stock'">
                                    <img src="assets/images/icons/stock.png" alt="">
                                    <span>{{tag}}</span>
                                </div>
                            </ng-container>
                        </ng-container>

                        <div class="image">
                            <a [routerLink]="['/' + product.city.name.toLowerCase().toString() + '/' + product.slug]">
                                <img src="{{product.featured_image}}" alt="{{product.title}}">
                            </a>
                        </div>
                    </div>
                    <div class="details w-45 text-center">

                        <div class="brand">
                            <div class="logo mb-2">
                                <img src="{{product.merchant?.logo}}" alt="">
                            </div>
                            <div class="brand-name">
                                <h5>
                                    <a [routerLink]="['/' + product.city.name.toLowerCase().toString() + '/' + product.slug]">
                    {{product.title}}
                  </a>
                                </h5>
                                <h6>{{product.category_name}}</h6>
                                <div class="location">
                                    <!--<img src="assets/images/icons/location-black.png" alt="">-->
                                    <i class="fa fa-map-marker"></i>&nbsp;
                                     <span>{{product.city?.name}}</span>
                                </div>
                            </div>
                        </div>

                        <div class="price">
                            <del *ngIf="product.cheapest_standard_deal?.regular_price"><i
                class="fa fa-rupee"></i> {{product.cheapest_standard_deal?.regular_price |  currency:'INR':'':'1.0-0'}}
              </del>
                            <div class="offer-price">
                                <h4><i class="fa fa-rupee"></i> {{product.cheapest_standard_deal?.sale_price | currency:'INR':'':'1.0-0'}}
                                </h4>
                                <p>onwards</p>
                            </div>
                        </div>

                        <a [routerLink]="['/' + product.city.name.toLowerCase().toString() + '/' + product.slug]" class="btn-yellow">BOOK</a>
                        <span class="vouchers" *ngIf="product.min_stocked_standard_deal">{{product.min_stocked_standard_deal?.stock}}
              Vouchers Left</span>
                        <span class="vouchers" *ngIf="!product.min_stocked_standard_deal">Sold Out</span>
                    </div>
                </div>
                <div class="pagination showpagination" *ngIf="response?.last_page >1">
                    <ul class="uk-pagination uk-flex-center" uk-margin>
                        <li class="uk-first-column"><a href="javascript:void(0)" (click)="goToPage(response.current_page - 1)"><span
              uk-pagination-previous></span></a></li>
                        <li *ngFor="let i of pages" [ngClass]="{'uk-active' : i == response.current_page}"><a href="javascript:void(0)" (click)="goToPage(i)"><span
              *ngIf="i<10">0</span> {{i}} </a></li>
                        <li><a href="javascript:void(0)" (click)="goToPage(response.current_page + 1)"><span
              uk-pagination-next></span></a>
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>


        <ng-container *ngIf="responseReceived && products.length === 0">
            <div class="heading-text-wrp text-center">
                <h5>No Results found for <span>"{{this.selectedKeyword}}"</span></h5>
                <div class="line"></div>
            </div>
        </ng-container>


    </div>
</section>

<app-footer></app-footer>